import { CookieKeys } from 'services/Cookies'
import { getPayloadFromJWT } from 'utils/jwt'
import { GetServerSideProps, GetServerSidePropsContext } from 'next'
import Cookies from 'cookies'
import { getStepFromData } from 'features/MealPlan/utils/getStepFromData'
import { ApiClient } from 'services/ApiClient'
import { PetAttempt, SubmitPetAttempt } from 'features/MealPlan/api/mutations/useSubmitPetAttempt'
import { RawFeedingProductType } from '../../models/Product'
import { ENV } from '../../constants/EnvHelp'

type UrlEncodedPetAttempt = Partial<PetAttempt> & {
  isSpayed?: string
  weight?: string
  isAlreadyOnRawDiet?: string
}

const filterPetData = (query: any) =>
  Object.entries(query).reduce((acc, [key, value]) => {
    if (!blacklist.includes(key)) return acc
    return {
      ...acc,
      [key]: value,
    }
  }, {})

const mergeData = (query: UrlEncodedPetAttempt, questionnaireData: PetAttempt | void) => {
  const urlData: Partial<PetAttempt> = {
    ...questionnaireData,
    ...filterPetData(query),
    isSpayed: query.isSpayed ? query.isSpayed === 'true' : questionnaireData?.isSpayed,
    weight: query.weight ? parseFloat(query.weight) : questionnaireData?.weight,
    ...(questionnaireData?.mealPlan && {
      mealPlan: {
        ...questionnaireData.mealPlan,
        rawFeedingProductType: questionnaireData.mealPlan.rawFeedingProductType
          ? questionnaireData.mealPlan.rawFeedingProductType
          : RawFeedingProductType.FROZEN,
      },
    }),
  }

  return urlData
}
const blacklist = [
  'name',
  'kind',
  'gender',
  'isSpayed',
  'birthDate',
  'promoCode',
  'breed',
  'size',
  'bodyCondition',
  'weightChangeDesire',
  'activityLevel',
  'weight',
  'allergies',
  'email',
  'mealPlan',
  'selectedProteins',
  'rawDietPercentage',
  'ownerId',
]

const filterWizzardFromQuery = (query: any) => {
  const filteredQuery = Object.entries(query).reduce((acc, [key, value]) => {
    if (blacklist.includes(key) && key != 'promoCode') return acc
    return {
      ...acc,
      [key]: value,
    }
  }, {})

  return new URLSearchParams(filteredQuery).toString()
}

const checkUser = async (ctx: GetServerSidePropsContext) => {
  const query = ctx.query as UrlEncodedPetAttempt
  const filteredQuery = filterWizzardFromQuery(ctx.query)

  const cookies = new Cookies(ctx.req, ctx.res)

  const isLogged = ctx.req.cookies[CookieKeys.SESSION]
  const guestIdentifier = query?.ownerId ?? ctx.req.cookies[CookieKeys.GUEST_ID]

  let userId = guestIdentifier

  if (isLogged) {
    userId = getPayloadFromJWT(isLogged).sub
    cookies.set(CookieKeys.GUEST_ID) // Delete the cookie, just in case
  }

  const questionnaireData = await ApiClient.get<PetAttempt>(`/v1/pet-attempts/${userId}`).catch(
    (e) => {
      console.log(e)
    }
  )

  const urlData: Partial<PetAttempt> = mergeData(query, questionnaireData)

  if (userId && urlData) {
    const response = await ApiClient.post<SubmitPetAttempt.Response>('/v1/pet-attempts', {
      data: {
        ...urlData,
        ownerId: userId,
      },
    })

    if (!isLogged) {
      cookies.set(CookieKeys.GUEST_ID, response.ownerId, {
        httpOnly: false,
      })
    }
  }

  const step = urlData
    ? getStepFromData(urlData)
    : !questionnaireData
    ? 'step-1'
    : getStepFromData(questionnaireData)

  return {
    redirect: {
      destination: `/meal-plan/${step}?${filteredQuery}`,
      permanent: false,
    },
  }
}

export const getServerSideProps: GetServerSideProps = checkUser

export default function MealPlan() {
  return <MealPlan />
}
